import * as React from 'react';
import factoryPaymentIcon from './utils/factoryPaymentIcon';
const SvgCardPlaceholderGrey = () => (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M0 5.50023C0 4.67168 0.805787 4 1.79977 4H22.2002C23.1942 4 24 4.67168 24 5.50023V18.4998C24 19.3283 23.1942 20 22.2002 20H1.79978C0.805788 20 0 19.3283 0 18.4998V5.50023Z", fill: "#EAEAEA" }),
    React.createElement("path", { d: "M0 8H24V11H0V8Z", fill: "#696969" }),
    React.createElement("rect", { x: "4", y: "16", width: "5", height: "1", rx: "0.5", fill: "#666666" })));
export default factoryPaymentIcon(SvgCardPlaceholderGrey);
//# sourceMappingURL=SvgCardPlaceholderGrey.js.map